import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import loadingLottie from "../../assets/lotties/loading-reviews.json";
import noResultsLottie from "../../assets/lotties/no-reviews-found.json";
import { getAllReviews } from "../../features/product/productThunks";
import AddReview from "../addReview/addReview";
import ReviewCard from "../reviewCard/reviewCard";
import "./reviewSection.css";

const ReviewSection = ({ productId }) => {
    const dispatch = useDispatch();
    const { reviews, loadingReviews } = useSelector((state) => state.product);

    useEffect(() => {
        if (productId) dispatch(getAllReviews(productId));
    }, [dispatch, productId]);

    return (
        <div className="review-section">
            <div className="review-div">
            <h2 className="review-title">Customer Reviews</h2>
            <AddReview productId={productId} />
            </div>
            <div className="reviews-list">
                {loadingReviews ? (
                    <div className="loader-container">
                        <Lottie animationData={loadingLottie} className="lottie-animation-loading" />
                    </div>
                ) : reviews.length > 0 ? (
                    reviews.map((review) => (
                        <ReviewCard key={review._id} review={review} />
                    ))
                ) : (
                    <div className="no-reviews">
                        <Lottie animationData={noResultsLottie} className="lottie-animation" />
                        <p className="no-reviews-paragraph">No reviews yet.</p>
                    </div>
                )}
            </div>

        </div>
    );
};

export default ReviewSection;
